import template from '../../../../../../Template/config/components/scorecard/ScorecardView/ScorecardStatTesting'
export default {
  ...template,
  legendDetails: "Negative sentiments shaded in reverse."
}
